module.exports = __webpack_public_path__ + "static/bricks-dc876695ebf5ddf827078da6fae6fac8.jpg";